import React from 'react';
import useStore from '../store/useStore';

function UnitSelection() {

  const unit = useStore((state) => state.unit);
  const setUnit = useStore((state) => state.setUnit);

    return (
      <div className="custom-border-color p-4">
      <div className="row">
          <div className="col-2 col-sm-4  col-lg-3">
            <div htmlFor="unit" className="fw-bold mt-2" id="text-primary">Unit</div>
          </div>
          <div className="col-12 col-sm-8 col-lg-9">
            <button 
                  type="button"
                  className="btn btn-lg  me-3"
                  id={`${unit === 'ft' ? 'btn-primary' : 'btn-light'}`} 
                  onClick={() => { setUnit('ft'); }}
                >
                  Feet
                </button>
                <button 
                  type="button"
                  className="btn btn-lg "
                  id={`${unit === 'm' ? 'btn-primary' : 'btn-light'}`}
                  onClick={() => { setUnit('m');}}
                >
                  Meter
            </button>
          </div>
      </div>
    </div>
    );
}

export default UnitSelection;
